import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../components/Admin/HeaderDash/HeaderDash';
import TiposClienteData from '../../components/Admin/TiposClienteData/TiposClienteData';

export default function TiposCliente() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <TiposClienteData />
                </div>
            </section>
        </div>
    );
}
